import { Badge, Button, Divider, Form } from 'antd';
import NoteItensIss from './NoteItensIss';
import NoteItensGeneralInfo from './NoteItensGeneralInfo';
import { FormInstance } from 'antd/es/form/Form';
import { InvoiceItemFormValues } from '@/core/domain/invoice/invoiceNoteItems/invoiceNoteItemsParts/InvoiceNoteItems.types';
import NoteItensRetention from './NoteItensRetention';
import NoteItensIbtp from './NoteItensIbtp';
import NoteItensDeduction from './NoteItensDeduction';
import NoteItensValues from './NoteItensValues';
import SpaceForButton from '@/components/_common/SpaceForButtons';
import { useLocation, useRouteMatch } from 'react-router-dom';
import ButtonBack from '@/components/_common/ButtonBack';
import TabsCustom from '@/components/_common/TabsCustom';
import { useEffect, useState } from 'react';
import { useCalcTaxesItems } from '@/core/domain/invoice/invoiceItem/invoiceItem.hook';
import { useInvoiceFormContext } from '@/components/Fiscal/Invoice/InvoiceFormProvider';
import { useCustomerGeneral } from '@/core/domain/people/Customers/Customers.hooks';

interface Props {
  form: FormInstance<InvoiceItemFormValues>;
  itemId?: number;
  handleValidateFieldsService?: () => Promise<boolean | undefined>;
  handleSubmit?: (redirect: false) => void;
  tabErrors?: Record<string, boolean>;
  loading?: boolean;
}

export default function InvoiceNoteItemsSelectServiceTabs({
  form,
  itemId,
  handleValidateFieldsService,
  handleSubmit,
  tabErrors,
  loading,
}: Props) {
  const { invoiceId } = useRouteMatch<{ invoiceId: string }>().params;
  const invoiceType = useLocation().pathname.split('/datas')[0].slice(20, 23);

  const [menuKeyActive, setMenuKeyActive] = useState<string>('general');

  const calculateTaxesItems = useCalcTaxesItems();

  const {
    invoiceSettingNfs,
    invoice: { data },
  } = useInvoiceFormContext();

  const { data: customer } = useCustomerGeneral(data?.customerId);

  useEffect(() => {
    if (invoiceSettingNfs && !!!itemId) {
      form.setFieldsValue({
        unitMeasurement: invoiceSettingNfs.unitMeasurementDefault,
        itemTaxes: {
          rate: invoiceSettingNfs.rateDefault,
          taxType: invoiceSettingNfs.taxTypeDefault,
          exigibility: invoiceSettingNfs.exigibilityDefault,
          withheld:
            typeof invoiceSettingNfs.withheldDefault === 'boolean'
              ? String(invoiceSettingNfs.withheldDefault)
              : customer?.retentionISS === true
              ? String(customer?.retentionISS)
              : undefined,
        },
      });
    }
  }, [invoiceSettingNfs, customer]);

  return (
    <Form form={form}>
      <TabsCustom
        key={menuKeyActive}
        activeKey={menuKeyActive}
        onChange={setMenuKeyActive}
      >
        <TabsCustom.Item
          label="Geral"
          key="general"
          icon={tabErrors?.general ? <Badge dot /> : null}
        >
          <NoteItensGeneralInfo form={form} />
        </TabsCustom.Item>

        <TabsCustom.Item
          label="Valores"
          key="values"
          icon={tabErrors?.values ? <Badge dot /> : null}
        >
          <NoteItensValues />
        </TabsCustom.Item>

        <TabsCustom.Item
          label="ISS"
          key="iss"
          icon={tabErrors?.iss ? <Badge dot /> : null}
        >
          <NoteItensIss />
        </TabsCustom.Item>

        <TabsCustom.Item label="Retenção" key="retention">
          <NoteItensRetention />
        </TabsCustom.Item>

        <TabsCustom.Item label="Dedução" key="deduction">
          <NoteItensDeduction />
        </TabsCustom.Item>

        <TabsCustom.Item label="IBPT" key="ibtp">
          <NoteItensIbtp />
        </TabsCustom.Item>
      </TabsCustom>

      <Divider />

      <SpaceForButton>
        <ButtonBack
          path={`/app/fiscal/invoice/${invoiceType}/${invoiceId}/noteItens`}
        />

        {!!itemId && (
          <Button
            type="primary"
            block
            onClick={async () => {
              if (handleValidateFieldsService) {
                const allFieldsFilled = await handleValidateFieldsService();

                if (allFieldsFilled && handleSubmit) {
                  await handleSubmit(false);
                  await calculateTaxesItems.mutateAsync(itemId);
                }
              }
            }}
            loading={loading || calculateTaxesItems.isLoading}
          >
            Calcular Tributos
          </Button>
        )}
      </SpaceForButton>
    </Form>
  );
}
